// portrSDK - methods for ga events
import PortrSDK from 'portr-javascript-sdk';

export default class GATrackingService {

  public portrSDK = new PortrSDK();

  constructor(
    private productString: string,
    private bookingRef: string,
    private statusString: string,
    private pram1: string,
    private pram2: string,
  ) {}

  sendPageView() {
    this.portrSDK.gaSendPageView(this.productString, this.bookingRef, this.statusString);
  }
  sendHitView() {
    this.portrSDK.gaHitLevel(this.pram1, this.pram2);
  }
};



// WEBPACK FOOTER //
// ./src/services/ga-tracking.service.tsx